module.exports = __webpack_public_path__ + "static/img/kos.464b651.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/kos.svg
// module id = 6y9A
// module chunks = 0